import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

export const firebaseConfig = {
  apiKey: "AIzaSyCzNpiFrdTscIuqOiLt265asV0dptIPwUU",
  authDomain: "mt-homepage-973f6.firebaseapp.com",
  projectId: "mt-homepage-973f6",
  storageBucket: "mt-homepage-973f6.firebasestorage.app",
  messagingSenderId: "673119026547",
  appId: "1:673119026547:web:2952d435c0f9e1e79ad906",
  measurementId: "G-YD3GD4DZY8"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Initialize analytics conditionally if supported in environment
export const analyticsPromise = isSupported().then((supported) => supported ? getAnalytics(app) : null);
